




























import { Prop, Component, Vue } from "vue-property-decorator";
import { Question } from "@/api/minutes-api";
import Action from "@/models/action";
import VToolbar from "../../../components/VToolbar.vue";
import taskSearchBar from "../components/TaskSearchBar.vue";
import { otherCompanyConstruction } from "../../api/other-company-construction-api";

@Component({
  components: {
    VToolbar,
    taskSearchBar
  }
})
export default class otherCompanyConstructionList extends Vue {
  @Prop({ default: () => [] }) actions!: Action[];
  @Prop({ default: () => [] }) questions!: Question[];
  @Prop({ default: () => [] })
  otherCompanyConstruction!: otherCompanyConstruction[];

  fields = [
    { key: "name", label: "他社参考工事名", sortable: true },
    { key: "shortName", label: "他社参考工事名短縮", sortable: true },
    { key: "construction", label: "工事", sortable: true }
  ];
}
